<template>
  <footer>
        <a href="http://istay.io" :target="target">
            <img src="@/assets/images/istay-orange-text.png" alt="">        
        </a>
  </footer>
</template>

<script>

// import Footer from '@/components/layout/Footer'

export default {

    name: 'Footer',
    props: {
          target: {
                type: String,
                defalut: ''
                //target='_blank' -- 새창
          }
    }


}
</script>

<style lang="scss" scoped>
$gray-200: #f4f4f4;
footer{
    height: 56px;
    @include flexs-align(center, center);
    background-color: $gray-200;
    width: 100%;
    // @include positions(absolute, unset, 0, 0 , 0);
    a{
        display: flex;
        img{
            height: 24px;
        }
    }
}
</style>